import { render, staticRenderFns } from "./PC_detail.vue?vue&type=template&id=bdf51c7e&scoped=true&"
import script from "./PC_detail.vue?vue&type=script&lang=js&"
export * from "./PC_detail.vue?vue&type=script&lang=js&"
import style0 from "./PC_detail.vue?vue&type=style&index=0&id=bdf51c7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf51c7e",
  null
  
)

export default component.exports